document.addEventListener("DOMContentLoaded", function() {

    // ajaxové donačítání obsahu
    //==========================
    window.pagerAjax = function() {
        const DELAY = 700;
        let clicks = 0;

        let el = document.querySelector('.js-pager-ajax-next-page-content');
        if(typeof(el) === 'undefined' || el === null)
            return;

        el.addEventListener('click', function (e) {
            const btn = e.target;

            if(!btn.matches('.js-pager-ajax-next-page:not(.loading)'))
                return;

            const pagerBottom = document.querySelector(".pages_bottom"),
                content = document.querySelector('.js-pager-ajax-content'),
                nextPage = btn.dataset.nextPage,
                lastPage = btn.dataset.lastPage;

            pagerBottom.classList.add('loading');
            content?.classList.add('loading');

            // aby nekdo nedelal dvoukliky
            if(clicks++ > 1)
                return;

            setTimeout(() => {
                const url = btn.dataset.url.replace('%d', nextPage);
                const dataBottom = {
                    'ajax': 1,
                    'ajax-block': 'BOTTOM',
                    'ajax-pager': 1,
                };

                const requestBottom = new XMLHttpRequest();
                requestBottom.open('GET', url.replace(/#.*$/, '') + (url.includes('?') ? '&' : '?') + dataToQueryString(dataBottom), true);

                requestBottom.onload = function() {
                    if (this.status >= 200 && this.status < 400) {
                        const pagerWrapper = pagerBottom.querySelector('.pagination-wrapper');
                        if(typeof(pagerWrapper) === 'undefined' || pagerWrapper === null)
                            return;

                        pagerWrapper.insertAdjacentHTML('beforebegin', this.response);
                        pagerWrapper.parentNode.removeChild(pagerWrapper);
                    }
                };

                requestBottom.send();

                const dataPager = {
                    'ajax': 1,
                    'ajax-block': 'PAGER',
                    'ajax-pager': 1,
                };

                const requestPager = new XMLHttpRequest();
                requestPager.open('GET', url.replace(/#.*$/, '') + (url.includes('?') ? '&' : '?') + dataToQueryString(dataPager), true);

                requestPager.onload = function() {
                    if (this.status >= 200 && this.status < 400) {
                        const html = this.response;
                        history.pushState({page: nextPage}, "title "+nextPage, url);

                        const newBtn = document.createElement("DIV");
                        newBtn.classList.add(...btn.classList);
                        newBtn.classList.add('newBtn');
                        newBtn.dataset.url = btn.dataset.url;
                        newBtn.dataset.lastPage = btn.dataset.lastPage;
                        newBtn.dataset.nextPage = (parseInt(nextPage) + 1).toString();
                        newBtn.innerHTML = btn.textContent;
                        btn.insertAdjacentElement('afterend', newBtn);
                        btn.parentNode.removeChild(btn);

                        content?.insertAdjacentHTML('beforeend', html);
                        content?.classList.remove('loading');
                        pagerBottom.classList.remove('loading');

                        if (nextPage === lastPage) {
                            newBtn.parentNode.removeChild(newBtn);
                            pagerBottom.classList.add('disabled');
                            const links = document.querySelector(".JS-estates-bottom-links");
                            if(typeof(links) != 'undefined' && links != null)
                                links.style.display = 'block';
                        }

                        window.lazyLoad();
                        window.matchHeight();
                        if (typeof window.pagerOnSuccess !== 'undefined')
                            window.pagerOnSuccess(newBtn, content, html);
                        const nemovitostiNactenyEvent = new Event ("nemovitostiNacteny");
                        const nemovitostiWrapper = document.querySelector(".js-pager-ajax-content");
                        nemovitostiWrapper.dispatchEvent(nemovitostiNactenyEvent);
                    }
                };

                requestPager.send();

                clicks = 0;
            }, DELAY);
        });
    };
    window.pagerAjax();

    // pokud neexistuje strankovani pak zobrazim odkazy
    const pager = document.querySelector('.js-pager-ajax-next-page-content');
    if(typeof(pager) != 'undefined' && pager != null) {
        const links = document.querySelector(".JS-estates-bottom-links");
        if(typeof(links) != 'undefined' && links != null)
            el.style.display = 'block';
    }
});